import { render, staticRenderFns } from "./studentsPage.vue?vue&type=template&id=c4ef6066&scoped=true&"
import script from "./studentsPage.vue?vue&type=script&lang=js&"
export * from "./studentsPage.vue?vue&type=script&lang=js&"
import style0 from "./studentsPage.vue?vue&type=style&index=0&id=c4ef6066&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef6066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ef6066')) {
      api.createRecord('c4ef6066', component.options)
    } else {
      api.reload('c4ef6066', component.options)
    }
    module.hot.accept("./studentsPage.vue?vue&type=template&id=c4ef6066&scoped=true&", function () {
      api.rerender('c4ef6066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/paymentPlans/studentsPage/studentsPage.vue"
export default component.exports